/**
 * Created by caoyu on 2021/12/4.
 */
import Vue from 'vue'

import AliPlayerVideo from "./AliPlayerVideo.vue"
import BesoWebRTCVideo from "./BesoWebRTCVideo.vue"
import H5PlayerVideo from "./H5PlayerVideo.vue"
import Rtsp2WsVideo from "./Rtsp2WsVideo.vue"
import AliPlayerHls2 from "./AliPlayerHls2.vue"
import AliPlayerHls2History from "./AliPlayerHls2History.vue"

Vue.component('AliPlayerVideo', AliPlayerVideo);
Vue.component('BesoWebRTCVideo', BesoWebRTCVideo);
Vue.component('H5PlayerVideo', H5PlayerVideo);
Vue.component('Rtsp2WsVideo', Rtsp2WsVideo);
Vue.component('AliPlayerHls2', AliPlayerHls2);
Vue.component('AliPlayerHls2History', AliPlayerHls2History);



// WEBPACK FOOTER //
// ./src/common/video/videocomponent.js